/** Case-insensitive "do any of these fields contain the term" helper. */
export function matchesSearch(term, ...fields) {
  const needle = String(term || '').trim().toLowerCase();
  if (!needle) return true;
  return fields.some((f) => String(f === null || f === undefined ? '' : f)
    .toLowerCase()
    .includes(needle));
}

export const humanize = key => String(key || '')
  .replace(/_/g, ' ')
  .replace(/\b\w/g, character => character.toUpperCase());